import { Entity, ProjectDevice } from '@moderepo/mode-internal-apis';
import { DeviceRegistrationWizardSettings } from '../../../utils/ritzUIExtensionUtils';

export const DEVICE_NAME_LENGTH_MIN = 1;
export const DEVICE_NAME_LENGTH_MAX = 1024;
export const DEFAULT_DEVICE_CONFIG_FILENAME = 'ug.json';



/**
 * Base component interface for all RegisterDeviceStep steps. All the Register Device step component must extends this interface.
 */
export interface RegisterDeviceStepProps {
    readonly projectId: number;
    // The device registration wizard can be used for editing existing device. The targetDevice will be provided if the wizard is being
    // used for editing existing device. And targetEntity can also be provided if we found an existing entity that match the device's ID.
    readonly targetDevice?: ProjectDevice | undefined;
    readonly targetEntity?: Entity | undefined;
    readonly deviceRegistrationWizardSettings: DeviceRegistrationWizardSettings;
    readonly canGoBack: boolean;
    readonly isLastStep: boolean;
    readonly onPrevStepClick: ()=> void;
    readonly onNextStepClick: ()=> void;
    readonly onGotoLastStepClick: ()=> void;
    readonly onStepError: (value: boolean)=> void;
}
